module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0139.jpg?v=1b54a926";